import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/21logo.jpg";
import { FaCartShopping } from "react-icons/fa6";
import { CartContext } from "../CartContext";
import CartProduct from "./CartProduct";
import { BsCartX } from "react-icons/bs";
import { FaShoppingBag } from "react-icons/fa";

const Navbar = () => {
  const cart = useContext(CartContext);
  const [toggle, setToggle] = useState(false);
  const handleToggle = () => setToggle(!toggle);
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const pathname = location.pathname;
  const [modal, setModal] = useState(false);
  const productsCount = cart.items.reduce(
    (sum, product) => sum + product.quantity,
    0
  );

  useEffect(() => {
    if (pathname === "/") {
      setActiveTab("home");
    } else if (pathname === "/produktet") {
      setActiveTab("produktet");
    } else if (pathname === "/kontakti") {
      setActiveTab("kontakti");
    }
  }, [pathname]);
  return (
    <Container>
      <Link to={"/"} className="link-styles">
        <img src={logo} alt="" className="logo" />
      </Link>
      <ul
        onClick={handleToggle}
        className={toggle ? "nav-menu active" : "nav-menu"}
      >
        <Link to={"/"} className="link-styles">
          <li className={activeTab === "home" ? "activeTab" : "nonActive"}>
            Home
          </li>
        </Link>

        <Link to={"/produktet"} className="link-styles">
          <li className={activeTab === "produktet" ? "activeTab" : "nonActive"}>
            Produktet
          </li>
        </Link>
        <Link to={"/kontakti"} className="link-styles">
          <li className={activeTab === "kontakti" ? "activeTab" : "nonActive"}>
            Kontakti
          </li>
        </Link>
        <FaCartShopping onClick={() => setModal(!modal)} className="cart" />
      </ul>
      <div className={modal ? "modal" : "closedModal"}>
        <span>
          <div>
            <FaShoppingBag className="icon" />
            <h3>Shporta jote ({productsCount})</h3>
          </div>
          <button className="x" onClick={() => setModal(false)}>
            x
          </button>
        </span>
        <div className="items">
          {productsCount !== 0 ? (
            <div className="item">
              {cart.items.map((currentProduct, idx) => (
                <CartProduct
                  key={idx}
                  id={currentProduct.id}
                  quantity={currentProduct.quantity}
                  title={currentProduct.title}
                />
              ))}
            </div>
          ) : (
            <div className="emptyCart">
              <BsCartX className="cartIcon" />
              <h3>Shporta juaj aktualisht është bosh.</h3>
            </div>
          )}
        </div>
        {productsCount !== 0 ? (
          <>
            <h2 className="totalPrice">
              Çmimi total: {cart.getTotalCost().toFixed(2)} €
            </h2>
            <Link to={"/checkout"} className="link-styles">
              <button onClick={() => setModal(false)}>Checkout</button>
            </Link>
          </>
        ) : (
          <></>
        )}
      </div>
      <div className="mobile-menu" onClick={handleToggle}>
        {toggle ? <FaTimes className="icon" /> : <FaBars className="icon" />}
      </div>
    </Container>
  );
};
const Container = styled.div`
  background: #ffffff47;
  transition: 0.4s;
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  position: fixed;
  /* top: 40px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1% 4%;
  width: 100%;
  height: 70px;
  z-index: 100;
  box-sizing: border-box;
  color: #464646;
  .logo {
    width: 60px;
    border-radius: 50%;
  }
  .nav-menu {
    display: flex;
    gap: 37px;
    list-style: none;
    align-items: center;
    li {
      color: #535353;
      font-weight: 400;
      transition: 0.3s;
      cursor: pointer;
      :hover {
        color: var(--fontPrimaryColor);
      }
    }
    .cart {
      font-size: 2em;
    }
    button {
      background: var(--fontPrimaryColor);
      border: none;
      color: var(--primaryBackgroundColor);
      padding: 7px 14px;
      font-size: 18px;
      border-radius: 20px;
      font-family: "Poppins", cursive;
      cursor: pointer;
      transition: 0.4s;
      :hover {
        box-shadow: 0 0 14px 2px var(--shadowColor);
      }
    }
    .activeTab {
      text-decoration: underline;
      text-underline-offset: 7px;
      font-weight: 600;
    }
  }
  .toggleTheme {
    .themeIcon {
      font-size: 1.6em;
      cursor: pointer;
      color: var(--fontPrimaryColor);
    }
  }
  .mobile-menu {
    position: absolute;
    color: var(--fontPrimaryColor);
    right: 5%;
    font-size: 24px;
    cursor: pointer;
    transition: 0.3s;
    display: none;
    margin-top: 7px;
    :hover {
      transform: scale(1.1);
    }
  }
  @media (max-width: 600px) {
    .logo {
      width: 45px;
    }
    .nav-menu {
      background: var(--primaryBackgroundColor);
      width: 90%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      padding: 10%;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0%;
      right: -100%;
      transition: 0.3s;
      z-index: 99;
      border-left: 1px solid var(--fontSecondaryColor);
    }
    .mobile-menu {
      display: block;
      z-index: 99;
    }
    .nav-menu.active {
      right: 0%;
    }
  }
  /* @media (max-width: 770px) {
    .nav-menu {
      background: var(--primaryBackgroundColor);
      width: 90%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      padding: 10%;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0%;
      right: -100%;
      transition: 0.3s;
      z-index: 99;
      border-left: 1px solid var(--fontSecondaryColor);
    }
    .mobile-menu {
      display: block;
      z-index: 99;
    }
    .nav-menu.active {
      right: 0%;
    }
  }
  @media (max-width: 400px) {
    .logo {
      width: 100px;
    }
    .nav-menu {
      width: 98%;
    }
  } */
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    overflow-y: scroll;
    width: 400px;
    max-width: 440px;
    background: #0f5014;
    color: white;
    padding: 2em 14px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px 2px var(--shadowColor);
    transition: 0.4s ease-in-out;
    .emptyCart {
      margin: 2em;
      .cartIcon {
        font-size: 4em;
        margin: auto;
        text-align: center;
        cursor: pointer;
      }
      h3 {
        margin-top: 10px;
        font-weight: 300;
        text-align: center;
        color: #ebe0d3;
      }
    }
    span {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 10px;
      div {
        display: flex;
        align-items: center;
        gap: 1em;
        .icon {
          color: white;
        }
        h3 {
          font-weight: 300;
        }
      }
      .x {
        color: white;
        background: none;
        border: none;
        font-size: 1.7em;
        position: absolute;
        right: 1em;
      }
    }
    .items {
      margin-top: 2em;
      .item {
        width: 100%;
        display: flex;
        gap: 1em;
        flex-direction: column;
        justify-content: space-between;
        img {
          width: 150px;
        }
        span {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          gap: 8px;
          h2 {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            h3 {
              font-size: 17px;
              font-weight: 400;
              width: 100%;
            }
            .icon {
              font-size: 1em;
              color: white;
            }
          }
          .h4 {
            font-size: 19px;
            font-weight: 300;
            color: #c7c7c7;
          }
          .quantity {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 4px;
            span {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 10px;
              button {
                display: flex;
                align-items: center;
                justify-content: center;
                align-self: flex-start;
                font-size: 30px;
                width: 30px;
                height: 30px;
                border: none;
                background: white;
                color: black;
                border-radius: 8px;
              }
              h1 {
                font-weight: 300;
              }
            }
          }
        }
      }
    }
    .totalPrice {
      font-weight: 400;
      margin: 1em;
      text-align: center;
    }
    button {
      background: white;
      border: none;
      margin: auto;
      display: flex;
      color: #202020;
      padding: 7px 14px;
      font-size: 18px;
      border-radius: 20px;
      font-family: "Poppins", cursive;
      cursor: pointer;
      transition: 0.4s;
      :hover {
        box-shadow: 0 0 14px 2px var(--shadowColor);
      }
    }
  }
  .closedModal {
    right: -200vw;
    position: fixed;
    transition: 0.4s;
  }
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    overflow-y: scroll;
    width: 400px;
    max-width: 440px;
    background: #012b16;
    color: white;
    padding: 2em 14px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px 2px var(--shadowColor);
    transition: 0.4s ease-in-out;
    .emptyCart {
      margin: 2em;
      .cartIcon {
        font-size: 4em;
        margin: auto;
        text-align: center;
      }
      h3 {
        margin-top: 10px;
        font-weight: 300;
        text-align: center;
        color: #ebe0d3;
      }
    }
    span {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 10px;
      div {
        display: flex;
        align-items: center;
        gap: 1em;
        .icon {
          color: white;
        }
        h3 {
          font-weight: 300;
        }
      }
      .x {
        color: white;
        background: none;
        border: none;
        font-size: 1.7em;
        position: absolute;
        right: 1em;
      }
    }
    .items {
      margin-top: 2em;
      .item {
        width: 100%;
        display: flex;
        gap: 1em;
        flex-direction: column;
        justify-content: space-between;
        img {
          width: 150px;
        }
        span {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          gap: 8px;
          h2 {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            h3 {
              font-size: 17px;
              font-weight: 400;
              width: 100%;
            }
            .icon {
              font-size: 1em;
              color: white;
            }
          }
          h4 {
            font-size: 17px;
            font-weight: 300;
            color: gray;
          }
          .quantity {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 4px;
            span {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 10px;
              button {
                display: flex;
                align-items: center;
                justify-content: center;
                align-self: flex-start;
                font-size: 30px;
                width: 30px;
                height: 30px;
                border: none;
                background: white;
                color: black;
                border-radius: 8px;
              }
              h1 {
                font-weight: 300;
              }
            }
          }
        }
      }
    }
    .totalPrice {
      font-weight: 400;
      margin: 1em;
      text-align: center;
    }
    button {
      background: white;
      border: none;
      margin: auto;
      display: flex;
      color: #202020;
      padding: 7px 14px;
      font-size: 18px;
      border-radius: 20px;
      font-family: "Poppins", cursive;
      cursor: pointer;
      transition: 0.4s;
      :hover {
        box-shadow: 0 0 14px 2px var(--shadowColor);
      }
    }
  }
`;

export default Navbar;
